/*
  Discount Engine offers in the cart drawer.
  Reads the rules JSON rendered into #DiscountEngineRules by layout/theme.liquid (shop metafield
  checkout.discount_engine, the same rules the cart transform applies at checkout) and, for each
  active rule whose condition matches the cart, fills the [data-cd2-offer] slot on its source lines
  (snippets/cart-drawer-v2.liquid) with:
    - a red note: the rule's `message` if set, else built from its title
      ("Delve Bed Frame + 2 Free Pillows" -> "Includes 2 free pillows");
    - a <cart-bundle-items> list (assets/cart-drawer-v2.js): the line's item plus the rule's
      target_variants x target_quantity, so the cart shows what checkout will bundle.
  Rule fields used: active, title, message, condition (ANY | ALL), source_variants,
  target_variants [{id}], target_quantity.
  The drawer re-renders by swapping its HTML, so slots are re-filled on every DOM change.
*/
(function () {
  var el = document.getElementById('DiscountEngineRules');
  if (!el) return;
  var rules;
  try {
    rules = JSON.parse(el.textContent);
  } catch (e) {
    return;
  }
  if (!Array.isArray(rules)) rules = [rules];
  rules = rules.filter(function (r) {
    return r && r.active !== false && Array.isArray(r.source_variants) && r.source_variants.length;
  });
  if (!rules.length) return;

  function escapeHtml(str) {
    return String(str == null ? '' : str).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  // message may be a string or [{key, value}] (the app's message rows); else use the title.
  function noteFor(rule) {
    var m = rule.message;
    if (typeof m === 'string' && m.trim()) return m.trim();
    if (Array.isArray(m) && m.length) {
      var text = m
        .map(function (row) {
          return row && (row.value || row.text);
        })
        .filter(Boolean)
        .join(' ');
      if (text) return text;
    }
    var title = String(rule.title || '');
    var plus = title.lastIndexOf(' + ');
    if (plus === -1) return title;
    return 'Includes ' + title.slice(plus + 3).toLowerCase();
  }

  function matches(rule, cartIds) {
    var src = rule.source_variants.map(String);
    var hit = src.filter(function (id) {
      return cartIds.indexOf(id) !== -1;
    });
    return rule.condition === 'ALL' ? hit.length === src.length : hit.length > 0;
  }

  function fill() {
    var slots = [].slice.call(document.querySelectorAll('[data-cd2-offer]'));
    if (!slots.length) return;
    var cartIds = slots.map(function (s) {
      return String(s.dataset.variantId);
    });
    slots.forEach(function (slot) {
      if (slot.dataset.filled === '1') return;
      slot.dataset.filled = '1';
      var html = '';
      rules.forEach(function (rule, r) {
        if (!matches(rule, cartIds)) return;
        if (rule.source_variants.map(String).indexOf(String(slot.dataset.variantId)) === -1) return;
        html += '<p class="cd2-offer__note">' + escapeHtml(noteFor(rule)) + '</p>';
        var targets = (rule.target_variants || []).filter(function (t) {
          return t && t.id;
        });
        // A line that is already a bundle keeps its own item list.
        if (!targets.length || slot.hasAttribute('data-has-bundle')) return;
        var qty = parseInt(rule.target_quantity, 10) || 1;
        var parts = [{ id: slot.dataset.variantId, quantity: 1 }].concat(
          targets.map(function (t) {
            return { id: t.id, quantity: qty };
          })
        );
        var count = parts.reduce(function (n, p) {
          return n + p.quantity;
        }, 0);
        var listId = 'CartDrawer-OfferList-' + slot.dataset.line + '-' + r;
        html +=
          '<cart-bundle-items class="cd2-bundle" data-key="' + escapeHtml(slot.dataset.key + ':offer' + r) +
          '" data-quantity="' + escapeHtml(slot.dataset.quantity) +
          '" data-composition="' + escapeHtml(JSON.stringify(parts)) + '">' +
          '<ul class="cd2-strip" role="list" aria-label="' + count + ' items">' +
          parts.map(function () {
            return '<li class="cd2-strip__item is-loading"><span class="cd2-strip__img"></span></li>';
          }).join('') +
          '</ul>' +
          '<button type="button" class="cd2-bundle-toggle" aria-expanded="false" aria-controls="' + listId +
          '" data-cd2-bundle-toggle data-label-hide="Hide ' + count + ' items" data-label-show="Show ' + count + ' items">' +
          '<span data-cd2-bundle-label>Show ' + count + ' items</span>' +
          '<svg viewBox="0 0 10 6" aria-hidden="true" focusable="false"><path d="M1 5l4-4 4 4" fill="none" stroke="currentColor" stroke-width="1.2"/></svg>' +
          '</button>' +
          '<ul class="cd2-bundle__list" id="' + listId + '" role="list" hidden></ul>' +
          '</cart-bundle-items>';
      });
      if (html) {
        slot.innerHTML = html;
        slot.hidden = false;
      }
    });
  }

  var queued = false;
  function schedule() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(function () {
      queued = false;
      fill();
    });
  }

  function start() {
    fill();
    var drawer = document.querySelector('cart-drawer');
    if (drawer) new MutationObserver(schedule).observe(drawer, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
